export const KASIR_ALLOWED_PATHS = ["/", "/setoran", "/keuangan", "/bbm-armada", "/piutang-pelanggan", "/rekonsiliasi-penjualan", "/buku-setoran-driver", "/pencarian", "/pelanggan", "/biaya-pabrik"];

export function isKasirRouteAllowed(pathname) {
  return KASIR_ALLOWED_PATHS.some((path) => {
    if (path === "/") return pathname === "/";
    return pathname === path || pathname.startsWith(path + "/");
  });
}
